import { IoMdClose } from "react-icons/io";

const Modal = ({ title, desc, isOpen, onClose, children }) => {
  return (
    <>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-[110] bg-black bg-opacity-50"
            onClick={onClose}
          ></div>
          <div className="fixed top-[50%] z-[120] left-[50%] rounded-lg bg-zinc-900 border br-1 shadow-2xl translate-x-[-50%] translate-y-[-50%] flex flex-col max-sm:w-[80%] sm:min-w-[200px] md:min-w-[600px] max-w-[calc(100vw-2rem)] max-h-[min(800px,calc(100vh-2rem))]  text-p-text">
            <div className="flex flex-col flex-1 min-h-0">
              <header className="flex items-center justify-between border-b border-zinc-700 br-1 px-8 py-4">
                <div className="flex flex-col gap-1">
                  <span className="text-lg font-semibold p-text">{title}</span>
                  <span className="text-sm text-s-text">{desc}</span>
                </div>
                <button
                  onClick={onClose}
                  type="button"
                  className="rounded-[3px] text-md font-semibold transition-colors duration-150 ease-in-out disabled:cursor-not-allowed text-xl"
                >
                  <IoMdClose />
                </button>
              </header>
              <div className="flex-1 overflow-y-auto">{children}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Modal;
